import type { ReactNode } from 'react';
import i18n from '@/lib/i18n';

/**
 * 별도의 언어 JSON 파일 없이, 각 페이지/컴포넌트에서 직접
 * 영어·한국어 텍스트를 인라인으로 지정할 수 있는 유틸.
 *
 * react-i18next 의 i18n.language 를 기준으로 동작하며,
 * I18nContext 의 언어 변경과 자동 동기화된다.
 *
 * @example
 * // 일반 텍스트
 * getText('Dashboard', '대시보드')
 *
 * // JSX 포함
 * getJSX(<>Welcome <strong>Admin</strong></>, <>관리자님 <strong>환영</strong>합니다</>)
 */

/**
 * 현재 i18n 언어 설정에 따라 영문/한국어 텍스트를 반환.
 * ko가 없으면 en을 fallback으로 사용한다.
 */
export function getText(en: string, ko?: string): string {
  if (i18n.language === 'ko' && ko != null) return ko;
  return en;
}

/**
 * JSX/ReactNode 버전의 getText.
 * 태그가 포함된 복잡한 다국어 콘텐츠를 처리할 때 사용한다.
 */
export function getJSX(en: ReactNode, ko?: ReactNode): ReactNode {
  if (i18n.language === 'ko' && ko != null) return ko;
  return en;
}
